import request from "@/utils/request";

export const url = {
  login: "/api/Auth/GetToken",
  setShift: "/api/Auth/SetShift", //设置班次
  logout: "/api/Auth/RemoveToken",
  versionNo: "/api/Common/GetVersionNo", //获取系统版本号
  RefreshToken: "/api/Auth/RefreshToken",

  GetRedirectFullUrl: "/api/WxAuth/GetRedirectFullUrl", //微信登录，获取Code的请求地址 Json提交
  GetUserInfoCallback: "/api/WxAuth/GetUserInfoCallback", //微信登录，获取用户信息
  SaveUserOpenId: "/api/WxAuth/SaveUserOpenId", //用户绑定OpenId
};
export function refreshToken(data) {
  return request({
    url: url.RefreshToken,
    method: "post",
    data: data,
  });
}
export function login(data) {
  return request({
    url: url.login,
    method: "post",
    data: data,
  });
}
export function logout(data) {
  return request({
    url: url.logout,
    method: "post",
    data: data,
  });
}
export function setShift(data) {
  return request({
    url: url.setShift,
    method: "post",
    data: data,
  });
}
export function getVersionNo(data) {
  return request({
    url: url.versionNo,
    method: "post",
    data: data,
  });
}
export function getRedirectFullUrl(data) {
  return request({
    url: url.GetRedirectFullUrl,
    method: "post",
    data: data,
  });
}
export function getUserInfoCallback(data) {
  return request({
    url: url.GetUserInfoCallback,
    method: "post",
    data: data,
  });
}

export function SaveUserOpenId(data) {
  return request({
    url: url.SaveUserOpenId,
    method: "post",
    data: data,
  });
}
